var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReCancelButtonIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3571 12.8574L7.64306 8.14331M7.64306 12.8574L12.3571 8.14331M10.0001 18.8337C14.6025 18.8337 18.3334 15.1027 18.3334 10.5003C18.3334 5.89795 14.6025 2.16699 10.0001 2.16699C5.39771 2.16699 1.66675 5.89795 1.66675 10.5003C1.66675 15.1027 5.39771 18.8337 10.0001 18.8337Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReCancelButtonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_CancelButton_icon.6d947af132b275c1a5a814244d76f078.svg";